import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Button, Collapse,
  Dropdown,
} from 'react-bootstrap5';

import { useNavigate } from 'react-router-dom';

import { useContext } from 'components/Members/Programs/Views/Show/Context';

import routes from 'app/routes';


import confirmAlert from 'components/new_ui/Alerts/confirm';
import IconWithText from 'components/Widgets/IconWithText';

import SessionStatus from './SessionStep/Status';
import Document from './Document';

export default function Step({
  step, iconClassName, iconBg, showStep, setShowStep, children,
}) {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const { dispatch, state, actions } = useContext();

  const onTopicChange = () => {
    navigate(routes.members.programs.program.step.changeTopic(step.id));
  };

  const onCompleteClick = () => {
    confirmAlert(
      {
        title: 'Complete Step',
        text: 'Are you sure you want to complete this step?',
        confirmButtonText: 'Complete',
      },
      () => {
        actions.completeStep(dispatch, step.id, () => {
        });
      },
    );
  };

  return (
    <>
      <Row className={
        `align-items-center ${(showStep === null || (showStep === step.id && !open)) ? '' : 'd-none d-lg-flex'}`
      }
      >
        <Col>
          <IconWithText
            wrapperClassName="step-info"
            contentClassName="w-100"
            iconClassName={step.completed || step.skipped
              ? `${iconClassName.includes('counting-icon') ? 'counting-icon' : ''} checkmark-icon bg-primary`
              : iconClassName}
            iconBg={step.completed || step.skipped ? 'bg-gray-100' : iconBg}
          >
            <Button
              variant="link"
              className="d-flex w-100 text-start text-decoration-none text-gray-900 fw-semibold"
              onClick={() => {
                setOpen(true);
                setShowStep(step.id);
              }}
              aria-controls={`step-${step.id}-collapse`}
              aria-expanded={open}
            >
              {step.title}

              <IconWithText
                iconClassName="chevron-icon small-icon"
                iconStyle={{ transform: 'rotate(-90deg)' }}
                wrapperClassName="d-lg-none ms-auto"
              />
            </Button>

            <SessionStatus status={step.status} />
          </IconWithText>
        </Col>

        <Col xs="auto" className="d-none d-lg-block">
          {children}

          <Button
            variant="light"
            className="ms-3 p-0 collapsed"
            style={{ borderRadius: '50%', borderBottomLeftRadius: '0' }}
            onClick={() => {
              setOpen(!open);
              setShowStep(!open ? step.id : null);
            }}
            data-bs-toggle="collapse"
            data-bs-target={`#step-${step.id}-collapse`}
            aria-controls={`step-${step.id}-collapse`}
            aria-expanded={open}
          >
            <IconWithText
              iconClassName="chevron-icon small-icon icon-toggle"
              wrapperClassName="p-2"
            />
          </Button>
        </Col>
      </Row>

      <Collapse in={open}>
        <div id={`step-${step.id}-collapse`} className="step-additional-data">
          <div className="d-block d-lg-none">
            <div className="d-flex mb-3">
              <Button
                variant="link"
                onClick={() => {
                  setOpen(false);
                  setShowStep(null);
                }}
                aria-controls={`step-${step.id}-collapse`}
                aria-expanded={open}
              >
                <IconWithText
                  iconClassName="chevron-icon small-icon"
                  iconStyle={{ transform: 'rotate(90deg)' }}
                  wrapperClassName="p-2"
                />
              </Button>

              <h1>{step.title}</h1>
            </div>

            <SessionStatus status={step.status} className="mb-3" />

            {children}
          </div>

          <div className="p-lg-3 p-lg-4 position-relative p-4">
            {step.is_completable && <div className="d-flex justify-content-end mb-2"><Button
              onClick={onCompleteClick}
              variant="light"
              className="btn-reverse ms-3 mb-3 mb-lg-0 step-action-btn"
            >
              Completed
            </Button></div>}

            <p className="small text-gray-800">
              {step.description}
            </p>

            {step.step_type === 'session' && (
              <>
                <Row className="mb-4">
                  <Col lg={6}>
                    <Document
                      title="Download Workbook"
                      url={step.workbook_link}
                      iconClassName="download-icon bg-gray-900"
                    />
                  </Col>
                </Row>

                {step.topic?.subtitles?.length > 0 && (
                  <>
                    <h6>Micro Lessons</h6>

                    <Row>
                      {step.topic.subtitles.map((subtopic) => (
                        <Col key={subtopic.id} lg={6} className="mb-3">
                          <Document
                            title={subtopic.name}
                            url={subtopic.link}
                            iconClassName="chevron-icon bg-gray-900"
                            iconStyle={{ transform: 'rotate(-90deg)' }}
                          />
                        </Col>
                      ))}
                    </Row>
                  </>
                )}
              </>
            )}

            {step.step_type === 'ai_session' && (
              <>
                {step.step_resources.length > 0 && (
                  <>
                    <h6>Resources</h6>

                    <Row>
                      {step.step_resources.map((resource) => (
                        <Col key={resource.id} lg={6} className="mb-3">
                          <Document
                            title={resource.attributes.title}
                            url=""
                            iconClassName="chevron-icon bg-gray-900"
                            iconStyle={{ transform: 'rotate(-90deg)' }}
                            onClick={() => {
                              navigate(routes.members.steps.content(state.program.id, step.id, resource.id));
                            }}
                          />
                        </Col>
                      ))}
                    </Row>
                  </>
                )}
              </>
            )}

            {step.is_topic_changeable && step.step_type === 'ai_session' && (
              <div className="position-absolute top-0 end-0 p-2">
                <Dropdown className="position-static">
                  <Dropdown.Toggle variant="" className="btn-link">
                    <div className="icon-with-text">
                      <i className="small-icon options-icon" />
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu align="end">
                    <Dropdown.Item
                      key="change-topic"
                      href={undefined}
                      rel="noreferrer"
                      onClick={onTopicChange}
                    >
                      <div className="icon-with-text">
                        <i className="small-icon edit-icon" />
                        <div className="text-content">
                          Change Topic
                        </div>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

            )}

          </div>
        </div>
      </Collapse>
    </>
  );
}

Step.propTypes = {
  step: PropTypes.object.isRequired,
  iconClassName: PropTypes.string.isRequired,
  iconBg: PropTypes.string,
  showStep: PropTypes.bool.isRequired,
  setShowStep: PropTypes.func.isRequired,
  children: PropTypes.node,
};

Step.defaultProps = {
  iconBg: '',
  children: null,
};
